import { QUIZ_ANSWER } from '../actions/Quiz.actions'

export const quizReducer = (state, action) => {
  switch (action.type) {
    case QUIZ_ANSWER:
      return {
        ...state,
        [action.payload.question]: {
          ...state[action.payload.question],
          answers: {
            ...state[action.payload.question].answers,
            // Reset previous selected answer
            ...Object.keys(state[action.payload.question].answers).reduce(
              (_, a) => {
                return {
                  ..._,
                  [a]: {
                    ...state[action.payload.question].answers[a],
                    selected: false
                  }
                }
              },
              state[action.payload.question].answers
            ),
            [action.payload.answer]: {
              ...state[action.payload.question].answers[action.payload.answer],
              selected: true
            }
          }
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/js/quiz/state/reducers/Quiz.reducer.jsx